import React, { useState } from 'react';

import { IChangeEvent } from '@rjsf/core';
import Form from '@rjsf/mui';
import { RJSFSchema } from '@rjsf/utils';
import validator from '@rjsf/validator-ajv8';
import fileDownload from 'react-file-download';

import { Alert, Button, Typography } from '@mui/material';

import { downloadBedbankPaymentsReport } from '~/services/ReportingService';
import { formatDateISO, startOfMonth, subMonths } from '~/services/TimeService';

import ErrorDisplay from '../ErrorDisplay';

const formSchema: RJSFSchema = {
  description: 'Please enter your dates to export the Bedbank payments report',
  type: 'object',
  properties: {
    startAt: {
      title: 'Select Start Date',
      type: 'string',
      format: 'date',
    },
    endAt: {
      title: 'Select End Date',
      type: 'string',
      format: 'date',
    },
    fileFormat: {
      title: 'File Format',
      type: 'string',
      enum: ['xlsx', 'email'],
    },
  },
};

const formData = {
  startAt: formatDateISO(startOfMonth(subMonths(1))),
  endAt: formatDateISO(startOfMonth()),
  fileFormat: 'email',
};

const uiSchema = {
  startAt: {
    'ui:widget': 'date',
  },
  endAt: {
    'ui:widget': 'date',
  },
  fileFormat: {
    'ui:widget': 'radio',
    'ui:options': {
      inline: true,
    },
  },
};

export default function ExportBedbankPaymentsReportForm() {
  const [successMessage, setSuccessMessage] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = (event: IChangeEvent) => {
    const { startAt, endAt, fileFormat } = event.formData;
    const fileName = `bedbank_payments_report_${startAt}_${endAt}.${fileFormat}`;

    downloadBedbankPaymentsReport({ startAt, endAt, fileFormat })
      .then((text) => {
        if (fileFormat != 'email') {
          fileDownload(text, fileName);
        } else {
          setSuccessMessage(true);
        }
      })
      .catch((err) => {
        setError(err.message);
      });
  };

  return (
    <Form
      schema={formSchema}
      uiSchema={uiSchema}
      formData={formData}
      onSubmit={handleSubmit}
      validator={validator}
      showErrorList={false}
    >
      <Button type="submit" variant="contained">
        Download/Email Payments Report
      </Button>
      {error && <ErrorDisplay message={error} />}

      {successMessage && (
        <Alert severity="success">
          <Typography>Your report is queued for delivery and will be emailed shortly.</Typography>
        </Alert>
      )}
    </Form>
  );
}
